declare var Alkami: any;

Alkami.Dom.onDocumentReady(() => {

    // We need to clear out all local storage entries for WidgetNav and TitleBarNav
    Alkami.WidgetNav.ResetWidgetNav();
    Alkami.WidgetNav.ResetWidgetTitleBars();

    // Remove Alkami sessionStorage keys
    const keys = Object.keys(window.sessionStorage);
    keys.forEach((key) => {
        if (key.toLowerCase().startsWith('alkami.')) {
            sessionStorage.removeItem(key);
        }
    });

    //Clear out available locales for language toggle if the object is present
    if (Alkami.LanguageToggle) {
        Alkami.LanguageToggle.ResetLocales();
    }
});
